export const COMMON_SLICK_SLIDER_OPTIONS = {
    rows: 0,
    mobileFirst: true,
    initialSlide: 0,
    arrows: true,
    dots: true,
    infinite: false
};

export const BREAKPOINT = {
    TABLET: 768,
    OLD_FASHION_DESKTOP: 1230,
    DESKTOP: 1440
};
